module.exports = __webpack_public_path__ + "static/img/002.af7f77f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/002.png
// module id = u1qz
// module chunks = 1